"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toIsoDatetimeString = exports.toDbDatetimeString = exports.toBoolean = void 0;
const moment_1 = __importDefault(require("moment"));
function toBoolean(value) {
    if (!value) {
        return false;
    }
    if (typeof value === "boolean") {
        return value;
    }
    if (typeof value === "number") {
        if (value === 1) {
            return true;
        }
        else {
            throw new Error("Number value is invalid.");
        }
    }
    if (typeof value === "string") {
        if (["1", "true", "yes"].includes(value)) {
            return true;
        }
        else if (["0", "false", "no"].includes(value)) {
            return false;
        }
        else {
            throw new Error("String value is invalid.");
        }
    }
    return value[0] === 1;
}
exports.toBoolean = toBoolean;
function toDbDatetimeString(value) {
    if (!value) {
        return "";
    }
    return moment_1.default(value).format("YYYY-MM-DD HH:mm:ss");
}
exports.toDbDatetimeString = toDbDatetimeString;
function toIsoDatetimeString(value) {
    if (!value) {
        return "";
    }
    return moment_1.default(value).toISOString();
}
exports.toIsoDatetimeString = toIsoDatetimeString;
//# sourceMappingURL=dataConverter.js.map